import { computed } from '@vue/composition-api'
import { breakComma, formatDateKanji, applicationNoIssuing } from '@/util/common'

export const ContractFreeTrialRequestComplete = (props, context) => {
  const store = context.root.$store
  const { trial: { data } } = store.state

  const applicationNo = computed(() => data.application_no ? '申込No.' + applicationNoIssuing(data.application_no) : '')

  const close = () => {
    context.emit('closeViewComplete')
  }

  return {
    close,
    data,
    formatDateKanji,
    breakComma,
    applicationNo
  }
}
